import type {
	Components,
} from '@mui/material'
import {
	bottomNavigationActionClasses,
} from '@mui/material'
import {
	touchRippleClasses,
} from '@mui/material'

export const materialUIBottomNavigationTheme: {
	components: Components
} = {
	components: {
		MuiBottomNavigation: {
			styleOverrides: {
				root: {
					backgroundColor: 'var(--surface-container-color)',
					boxShadow:       'none',
					borderTop:       'var(--outline-base)',
					overflow:        'hidden',
				},
			},
		},
		MuiBottomNavigationAction: {
			styleOverrides: {
				root: {
					color:      'var(--secondary-hint-color)',

					fontWeight: 600,
					padding:    'var(--base-spacing-1)',

					[`& .${touchRippleClasses.root} .${touchRippleClasses.child}`]: {
						color: 'var(--primary-color)',
					},

					[`.${bottomNavigationActionClasses.label}`]: {
						fontSize: 'var(--font-size-body-xs-small)',

						[`&.${bottomNavigationActionClasses.selected}`]: {
							fontSize: 'var(--font-size-body-xs-small)',
						},
					},

					[`&.${bottomNavigationActionClasses.selected}`]: {
						color: 'var(--primary-color)',
					},
				},

			},
		},
	},
}
